import React from 'react';
import './CTA.css';

function CTA() {
    return (
        <section className="cta-section">
            <h2>Есть задача?<br />Давайте обсудим</h2>
            <p>Расскажите о вашем проекте — оценим стек, объём и сроки без обязательств.</p>

            <div className="cta-actions">
                <a href="mailto:support@aicoll.ru" className="btn btn-accent">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                    </svg>
                    Связаться с нами
                </a>
                <a href="/app.html" className="btn btn-ghost btn-ghost--dark">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                    Открыть приложение
                </a>
            </div>
        </section>
    );
}

export default CTA;
